import type { MenuProps } from "@mantine/core";

/**
 * Placement spec for table-row "More" (⋮) menus (ING-932): right-aligned to the
 * icon with a 4px gap, opening below and flipping above when out of room.
 *
 * `withinPortal: false` is what makes the flip fire at the table's edge rather
 * than the viewport's: Floating UI's flip middleware collides against the
 * dropdown's own clipping ancestors, so the dropdown must live inside the
 * table card (RpiTableContainer, overflow: hidden) for the card to become the
 * collision boundary. Portaled to <body>, its only boundary is the viewport
 * and bottom-row menus spill past the table footer instead of flipping.
 * The dropdown still escapes the horizontal scroller (OverflowX) because its
 * absolute-position containing block is OverflowX's relative root, above it.
 */
export const tableRowMenuPosition: Pick<MenuProps, "position" | "offset" | "withinPortal"> = {
  position: "bottom-end",
  offset: 4,
  withinPortal: false,
};
